import React, { useState, useContext, useEffect } from "react";
import { Form, Input, Select, Button, Row, Col, Switch, Modal, notification  } from "antd";
import axios from "axios";
import GlobalContext from "../../utils/GlobalContext";
import mergeProps from "../../utils/MergeProps";
// import LoadingModal from "../../utils/LoadingModal";

const { Option } = Select;

const UserForm = ({open, isEdit, currentUser, onFinish, onCancel }) => {
  const globals = useContext(GlobalContext);
  const [form] = Form.useForm();
  const [loginType, setLoginType] = useState("local");

  useEffect(() => {
    setLoginType("local");
    form.setFieldsValue({
      role: "user",
      loginGoogle: false,
    });
  }, [open, form]);

  useEffect(() => {
    if (isEdit) {
      form.setFieldsValue({
        firstName: currentUser.firstName,
        lastName: currentUser.lastName,
        email: currentUser.email,
        role: currentUser.role,
        loginGoogle: currentUser.type.toLowerCase() === "google" ? true : false,
      });
      setLoginType(currentUser.type.toLowerCase());
    }
  }, [isEdit, currentUser, form]);

  const handleComplete = async (values) => {
    try {
      values.firstName = values.firstName.trim();
      values.lastName = values.lastName.trim();
      values.email = values.email.trim();
      values.role = "user";
      values.loginGoogle = false;
      if (isEdit && (values.password === "" || values.password === undefined)) {
        values.password = "";
      }
      values.role = values.role.trim();
      values.type = values.loginGoogle ? "google" : "local";

      // Remove temp values from values
      delete values.confirmPassword;
      delete values.loginGoogle;

      if (isEdit) {
        values.id = currentUser.id;
        const response = await axios.put(`${globals.SERVICE_API_DB}/v1/update-user/${currentUser.id}`,
          values,
          {
            headers: {
              "x-token": globals.token,
            }
          }
        );
        if (response?.data?.status === 0) {
          currentUser = mergeProps(currentUser, response?.data?.data);
          onFinish({status: "edited"}) 
        }
        form.resetFields();
        return;
      }
      const response = await axios.post(`${globals.SERVICE_API_DB}/v1/create-user`,
        values,
        {
          headers: {
            "x-token": globals.token,
          }
        }
      );
      onFinish({status: "created", newUser: response?.data?.data})
      form.resetFields();
    } catch (error) {
      console.error("Error submitting form:", error);
      if (error?.response?.data?.msg === "User already exists") {
        notification.error({
          message: "Email ya existe en el sistema",
          placement: "bottomRight",
        });
      }
      else{
        notification.error({
          message: "Error guardando usuario",
          placement: "bottomRight",
        });
      }
    } 
    // finally {
    //   form.resetFields();
    // }
  };

  const handleCancel = () => {
    form.resetFields();
    onCancel();
  }

  const handleGoogleLoginChange = (checked) => {
    setLoginType(checked ? "google" : "local");
  };

  const passwordValidator = ({ getFieldValue }) => ({
    validator(_, value) {
      if (!value || getFieldValue('password') === value) {
        return Promise.resolve();
      }
      return Promise.reject(new Error('Las contraseñas no coinciden'));
    },
  });

  return (
    <Modal
        title={isEdit ? "Editar Usuario Externo" : "Crear Usuario Externo" }
        open={open}
        onOk={handleCancel}
        onCancel={handleCancel}
        footer={null}
      >
    {/* <LoadingModal open={loading} /> */}
    <Form
      form={form}
      layout="vertical"
      onFinish={handleComplete}
    >
      <Form.Item
        label="Email"
        name="email"
        rules={[
          { required: true, message: "Este campo es requerido" },
          { type: 'email', message: "Ingrese un email válido" },
        ]}
      >
        <Input disabled={isEdit}/>
      </Form.Item>
      <Row gutter={16}>
        <Col span={12}>
          <Form.Item
            label="Nombre"
            name="firstName"
            rules={[{ required: true, message: "Este campo es requerido" }]}
          >
            <Input />
          </Form.Item>
        </Col>
        <Col span={12}>
        <Form.Item
            label="Apellido"
            name="lastName"
            rules={[{ required: true, message: "Este campo es requerido" }]}
          >
            <Input />
          </Form.Item>
        </Col>
      </Row>
      {/* <Form.Item label="Tipo de login" name="loginGoogle" valuePropName="checked">
        <Switch
          checkedChildren="google"
          unCheckedChildren="local"
          onChange={handleGoogleLoginChange}
        />
      </Form.Item> */}
      {loginType.toLowerCase() === "local" && (
        <>
          <Row gutter={16}>
            <Col span={12}>
              <Form.Item
                label="Contraseña"
                name="password"
                rules={[
                  { required: !isEdit, message: "Este campo es requerido" },
                  { min: 6, message: "La contraseña debe tener al menos 6 caracteres" },
                ]}
              >
                <Input.Password />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                label="Confirmar contraseña"
                name="confirmPassword"
                rules={[
                  { required: !isEdit, message: "Este campo es requerido" },
                  passwordValidator,
                ]}
              >
                <Input.Password />
              </Form.Item>
            </Col>
          </Row>
        </>
      )}
      {/* <Form.Item
        label="Rol"
        name="role"
        rules={[{ required: true, message: "Este campo es requerido" }]}
      >
        <Select>
          <Option value="admin">admin</Option>
          <Option value="user">usuario</Option>
        </Select>
      </Form.Item> */}
      <Row justify="end">
        <Col>
          <Button style={{ marginRight: 8 }} type="primary" htmlType="submit">
            {isEdit ? "Actualizar" : "Crear"}
          </Button>
          <Button style={{ marginRight: 8 }} onClick={handleCancel}>
            Cancelar
          </Button>
        </Col>
      </Row>
    </Form>
    </Modal>
  );
};

export default UserForm;
